var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "VueScroll" }, [
    _c(
      "div",
      {
        ref: "VueScroll",
        staticClass: "mescroll",
        attrs: { id: _vm.id + _vm.index }
      },
      [
        _c("ul", { staticClass: "VueScroll-ul" }, [
          _c("li", [_vm._t("default")], 2),
          _c("li", [_c("bottom-fixed-blank")], 1)
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38a6b337", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a6b337","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueScroll/VueScroll.vue
// module id = 663
// module chunks = 25